module.exports = __webpack_public_path__ + "img/c01_unitstartechtwomansaw_Normal_ua.de47428d.webp";